/**
 * Search Item - FutureShop
 */

// 絞り込み検索
export function fsSearchItemCheckbox() {
  // document.addEventListener('DOMContentLoaded', function() {
  //   var checkboxGroups = document.querySelectorAll('.fs-c-checkboxGroup.u-checkbox__sp2col[data-select-group=radio]');

  //   checkboxGroups.forEach(function(group) {
  //     group.addEventListener('click', function(event) {
  //       if (event.target.classList.contains('fs-c-checkbox__checkbox') && event.target.type === 'checkbox') {
  //         handleCheckboxClick(event.target, group);
  //       }
  //     });
  //   });

  //   function handleCheckboxClick(clickedCheckbox, group) {
  //     var checkboxes = group.querySelectorAll('.fs-c-checkbox__checkbox');

  //     checkboxes.forEach(function(checkbox) {
  //       checkbox.checked = false;
  //     });

  //     clickedCheckbox.checked = true;
  //   }
  // });

  document.addEventListener('DOMContentLoaded', function() {
    // チェックボックスグループの選択
    var checkboxGroups = document.querySelectorAll('.fs-c-checkboxGroup.u-checkbox__sp2col[data-select-group="radio"]');

    checkboxGroups.forEach(function(group) {
      var checkboxes = group.querySelectorAll('.fs-c-checkbox__checkbox');

      checkboxes.forEach(function(checkbox) {
        checkbox.addEventListener('click', function(event) {
          handleCheckboxClick(event, checkboxes);
        });
      });
    });

    function handleCheckboxClick(event, checkboxes) {
      var clickedCheckbox = event.target;

      if (clickedCheckbox.checked) {
        // すべてのチェックボックスのチェックを外す
        checkboxes.forEach(function(checkbox) {
          checkbox.checked = false;
        });
        // クリックされたチェックボックスにチェックを入れる
        clickedCheckbox.checked = true;
      } else {
        // チェックされていない場合はそのまま
        clickedCheckbox.checked = false;
      }
    }
  });






}
